<template>
  <v-autocomplete
    :value="value"
    @change="v => $emit('input', v)"
    :items="getPreparationSlipTemplates.filter(x => x.is_deleted !== true)"
    item-text="name"
    item-value="id"
    :solo-inverted="soloInverted"
    label="Gabarit de bon de préparation"
    autocomplete="off"
    hide-details
    filled
    class="no-before"
    dense
    single-line
  ></v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PreparationSlipTemplateSelector",
  props: {
    value: {
      required: true
    },
    soloInverted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getPreparationSlipTemplates"])
  }
};
</script>

<style></style>
